import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, Observable, Subscription, switchMap } from 'rxjs';
import { CollapseItem } from '../../../../../../components/collapse-list/model/collapse.model';
import { CmsService, ProductScope, WindowRef } from '@spartacus/core';
import { CmsComponentData, CurrentProductService } from '@spartacus/storefront';
import { TabContainer, TabEntry } from './core/tab-container.model';
import { ToolsService } from '../../../../../../core/services/tools.service';
import { DEVICE_SIZE } from '../../../../../../core/models/others.model';
import { ProductShortcutService } from '../../../../product/product-shortcut-features/core/product-shortcut.service';

@Component({
  selector: 'tab-container',
  templateUrl: './tab-container.component.html',
  styleUrl: './tab-container.component.scss',
  standalone: false,
})
export class TabContainerComponent implements OnInit, OnDestroy {
  collapseList$ = new BehaviorSubject<CollapseItem[]>([]);
  subscription = new Subscription();

  components$: Observable<any[]> = this.componentData.data$.pipe(
    distinctUntilChanged((x, y) => x?.tabs === y?.tabs),
    switchMap((data: TabContainer) =>
      combineLatest(
        (data?.tabs ?? '').split(' ').map(tab =>
          this.cmsService.getComponentData<any>(tab).pipe(
            distinctUntilChanged(),
            map(tab => {
              if (!tab) {
                return undefined;
              }

              if (!tab.flexType) {
                tab = {
                  ...tab,
                  flexType: tab.typeCode,
                };
              }

              return tab;
            }),
          ),
        ),
      ),
    ),
  );

  constructor(
    public componentData: CmsComponentData<any>,
    protected cmsService: CmsService,
    protected winRef: WindowRef,
    protected currentProductService: CurrentProductService,
    protected toolsService: ToolsService,
    protected productShortcutService: ProductShortcutService,
  ) {}

  ngOnInit(): void {
    this.createCollapseList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  createCollapseList() {
    this.subscription.add(
      combineLatest([
        this.components$,
        this.currentProductService.getProduct([ProductScope.DETAILS, ProductScope.PRICE]),
      ]).subscribe(([components, product]) => {
        let componentList: CollapseItem[] = components.map((component: TabEntry) => {
          return {
            id: component.uid || '',
            title: component.title || '',
            cxComponent: component,
            hostClass: component.styleClasses || '',
            isOpen: component.isActive === 'true',
          };
        });

        const viewResourceTab = [DEVICE_SIZE.TABLET, DEVICE_SIZE.MOBILE];
        const hasResourceTab = componentList.find(component => component.id === 'TabResourceCenter');

        if (hasResourceTab && !viewResourceTab.includes(this.toolsService.getCurrentSize())) {
          componentList = componentList.filter(component => component.id !== 'TabResourceCenter');
        }

        const hasKeySpec = product?.keySpecs?.length;

        if (!hasKeySpec) {
          componentList = componentList.filter(component => component.id !== 'TabKeyFeatures');
        }

        this.collapseList$.next(componentList);
      }),
    );
  }
}
